export default __webpack_public_path__ + "static/media/icon-checkmark-filled-active.d22cd5c5.svg";